import React, { FC } from 'react';

export const RadioIcon: FC<React.PropsWithChildren<{ className?: string }>> = ({
  className = ''
}) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Radio Icon">
        <rect id="Blue" width="20" height="20" rx="10" fill="black" />
        <rect id="White" x="6" y="6" width="8" height="8" rx="4" fill="white" />
      </g>
    </svg>
  );
};
